import './styles.css';

import React, { Component } from 'react';
import  {Route, Link, Switch} from "react-router-dom"
import LandingPageHeader from "../../components/LandingPageHeader/LandingPageHeader";
import HeaderText from "../../components/HeaderText/HeaderText";
import Content from "../../content/Content";
import InformationLabel from "../../components/InformationLabel/InformationLabel";
import InformationLabelListContent from "../../components/InformationLabelListContent/InformationLabelListContent";
import InformationLabelContentList from "../../components/InformationLabelContentList/InformationLabelContentList";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import Footer from "../../components/Footer/Footer";
import {checkAuth} from "../../services/BaseServiceHandler";
import Constants from "../../constants/Constants";
import DataPanelLoadingView from "../../components/LoadingViews/DataPanelLoadingView";
import Gutter from '../../components/Gutter/Gutter';

class PrivacyAndPolicies extends Component {

    constructor(props){
        super(props);

        this.state = {
            isAuthenticatedUser: false,
            serverCallStatus : Constants.REQUEST_STATS.PENDING,
        };
        this.refGetInTouch=null;
    }

    componentWillMount() {
        
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        checkAuth(this.onCheckAuthSuccess, this.onCheckAuthFailure);
    }

    onCheckAuthSuccess = (authData) => {
        if(authData) {
            this.setState({
                isAuthenticatedUser: true,
                serverCallStatus: Constants.REQUEST_STATS.SUCCESS
            });
        }
        else {
            this.setState({
                serverCallStatus: Constants.REQUEST_STATS.SUCCESS
            });
        }
    };

    onCheckAuthFailure = () => {
        this.setState({
            serverCallStatus: Constants.REQUEST_STATS.SUCCESS
        });
    };

    onClickGetInTouch = () => {
        window.scrollTo(0, this.refGetInTouch.offsetTop ? this.refGetInTouch.offsetTop-60 : 0);
    };

    getDataView = () => {

        let customStyleHeaderText = {
            background: '#0028ea',
            color: '#FFF'
        };

        if(this.state.isAuthenticatedUser) {
            customStyleHeaderText = {
                background: '#F5F5F5',
                color: '#000'
            }
        }

        return (
            <div className="privacy-policy">

                <LandingPageHeader
                    isAuthenticatedUser = {this.state.isAuthenticatedUser}
                    onClickGetInTouch = {this.onClickGetInTouch}
                    {...this.props}
                />

                <div style = {{paddingTop: '60px'}}></div>

                <HeaderText
                    headerText = {Content.HEADER_TEXT.PRIVACY_POLICY}
                    customStyleHeaderText = {customStyleHeaderText}
                />

                <div className="pp-content-wrapper">

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.PARAGRAPH_1}
                    />
                    <InformationLabelListContent
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.PARAGRAPH_1_LIST_1}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[0]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.PARAGRAPH_1_LIST_2}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[1]}
                    />

                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.PARAGRAPH_2, Content.PRIVACY_POLICY_CONTENT.PARAGRAPH_3]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_1.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_1.HEADER_CONTENT_1]}
                    />
                    <Gutter height={10} />
                    <InformationLabelListContent
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_1.HEADER_CONTENT_1_LIST.LIST_1}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[0]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_1.HEADER_CONTENT_1_LIST.LIST_2}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[1]}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_1.HEADER_CONTENT_2]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_1.HEADER_CONTENT_2_LIST.LIST_1}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[0]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_1.HEADER_CONTENT_2_LIST.LIST_2}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[1]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1]}
                    />
                    <Gutter height={10} />
                    <InformationLabelListContent
                        informationLabelListStrongContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST_HEADER.HEADER_1}
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST.LIST_1}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[0]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST_HEADER.HEADER_2}
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST.LIST_2}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[1]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST_HEADER.HEADER_3}
                        informationLabelListContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST.LIST_3}
                        informationLabelListStrongCount={Content.INDEX_TO_ALPHABET_MAPPING[2]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent={Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST_HEADER.HEADER_4}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST.LIST_4}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[3]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST_HEADER.HEADER_5}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST.LIST_5}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[4]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST_HEADER.HEADER_6}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1_LIST.LIST_6}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[5]}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_2]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_3.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_2.HEADER_CONTENT_1]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST_HEADER.HEADER_1}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST.LIST_1}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[0]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST_HEADER.HEADER_2}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST.LIST_2}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[1]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST_HEADER.HEADER_3}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST.LIST_3}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[2]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST_HEADER.HEADER_4}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST.LIST_4}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[3]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST_HEADER.HEADER_5}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_4.HEADER_CONTENT_1_LIST.LIST_5}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[4]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_5.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_5.HEADER_CONTENT_1]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_6.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_6.HEADER_CONTENT_1]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1]}
                    />
                    <Gutter height={10} />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_1}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[0]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_2}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[1]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_3}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[2]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_4}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[3]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_5}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[4]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_6}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[5]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_7}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[6]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_8}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[7]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_9}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[8]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_10}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[9]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_7.HEADER_CONTENT_1_LIST.LIST_11}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[10]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_8.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_8.HEADER_CONTENT_1]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER_CONTENT_1_LIST.LIST_1}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[0]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER_CONTENT_1_LIST.LIST_2}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[1]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER_CONTENT_1_LIST.LIST_3}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[2]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER_CONTENT_1_LIST.LIST_4}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[3]}
                    />
                    <InformationLabelListContent
                        informationLabelListStrongContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER_CONTENT_1_LIST_HEADER.HEADER_5}
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER_CONTENT_1_LIST.LIST_5}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[4]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER_CONTENT_1_LIST.LIST_6}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[5]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_9.HEADER_CONTENT_1_LIST.LIST_7}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[6]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_10.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_10.HEADER_CONTENT_1]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_11.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_11.HEADER_CONTENT_1]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_12.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_12.HEADER_CONTENT_1, Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_12.HEADER_CONTENT_2, Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_12.HEADER_CONTENT_3]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_12.HEADER_CONTENT_1_LIST.LIST_1}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[0]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_12.HEADER_CONTENT_1_LIST.LIST_2}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[1]}
                    />
                    <InformationLabelListContent
                        informationLabelListContent = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_12.HEADER_CONTENT_1_LIST.LIST_3}
                        informationLabelListStrongCount = {Content.INDEX_TO_ALPHABET_MAPPING[2]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_13.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_13.HEADER_CONTENT_1, Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_13.HEADER_CONTENT_2]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_14.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_14.HEADER_CONTENT_1]}
                    />
                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_15.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_15.HEADER_CONTENT_1]}
                    />

                    <InformationLabel
                        infoLabel = {Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_16.HEADER}
                    />
                    <InformationLabelContentList
                        infoLabelContentListContent = {[Content.PRIVACY_POLICY_CONTENT.INFORMATION.INFO_16.HEADER_CONTENT_1]}
                    />

                </div>
                <Gutter height={20} />
                <div ref={ref => this.refGetInTouch=ref}></div>
                <div className="get-in-touch-wrapper">
                    <GetInTouch />
                </div>

                <Footer />
            </div>
        )
    };

    getLoadingPage = ()=>{
        return(
            <DataPanelLoadingView/>
        );
    };


    getViewTobeRendered = (serverCallStatus) => {
        let renderView = null ;

        switch (serverCallStatus){
            case 1:
                renderView =  this.getLoadingPage();
                break;
            case 2:
                renderView = this.getDataView();
                break;
            default:
                break;
        }
        return renderView;
    };

    render() {

        return (
            this.getViewTobeRendered(this.state.serverCallStatus)


        )

    }

}

export default PrivacyAndPolicies;



// WEBPACK FOOTER //
// ./src/scenes/PrivacyAndPolicies/PrivacyAndPolicies.js